"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commerceMall = void 0;
var utils_1 = require("../../utils");
exports.commerceMall = function (axios) {
    return {
        //몰별 도메인 연결리스트 조회
        getMallsMallNoDomains: function (request) {
            return axios.get("/malls/" + request.pathParams.mallNo + "/domains");
        },
        //몰별 도메인 SSL 설치리스트 조회
        getMallsMallNoSsl: function (request) {
            return axios.get("/malls/" + request.pathParams.mallNo + "/ssl");
        },
        // 몰의 도메인 구매/연결 유효성 검사
        getMallsMallNoDomainsCheckByAvailability: function (request) {
            var url = utils_1.paramPathchange('/malls/{mallNo}/domains/check-buy-availability', request);
            return axios.get(url, request);
        },
        //몰별 도메인 연결 개수 조회
        getMallsMallNoDomainsCount: function (request) {
            return axios.get("/malls/" + request.pathParams.mallNo + "/domains/count");
        },
        //몰의 대표도메인 변경
        putMallsMallNoMainDomainDomainNo: function (request) {
            if (!request.headers) {
                return axios.put("/malls/" + request.pathParams.mallNo + "/main-domain/" + request.pathParams.domainNo);
            }
            var config = {
                headers: __assign({}, request.headers)
            };
            return axios.put("/malls/" + request.pathParams.mallNo + "/main-domain/" + request.pathParams.domainNo, config);
        }
    };
};
